import { FC } from 'react';
import styled from 'styled-components';
import AuthService from '../../../services/auth/authService';
import Constants from '../../../constants/constants';
import LevelsWidget from './LevelsWidget';
import BadgesWidget from './BadgesWidget';
import AchievementsWidget from './AchievementsWidget';

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

const Grid = styled.div`
  flex-shrink: 1;
  display: inline-grid;
  grid-template-columns: minmax(auto, 1143px) minmax(75px, 220px);
  grid-template-rows: 1fr 1fr 1fr minmax(30px, 55px);
  grid-template-areas:
    'map level'
    'map badges'
    'map achievements'
    'map button';
  grid-gap: 5px;
  align-items: top;
  width: 100%;
  max-width: 1368px;
`;

const Map = styled.div`
  grid-area: map;
`;

const FrameWrapper = styled.div`
  height: 0;
  width: 100%;
  padding-bottom: 62.57%;
  width: auto;
  position: relative;
`;

const Frame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const StartButton = styled.button(({ theme }) => {
  const { color } = theme;

  return `
    background: rgb(240, 76, 88);
    border: none;
    padding: 13px 44px;
    border-radius: 0 0 30px 0;
    cursor: pointer;
    color: ${color.grayscale[1000]};
    width: 100%;
    font-size: 1.125rem;
    transition: 0.2s;
    grid-area: button;

    &:hover {
      background: rgb(182, 57, 67);
    }
  `;
});

interface ProgressMapProps {
  homeUser: {
    home_progress: number;
  };
  startFunc: () => void;
}

const ProgressMap: FC<ProgressMapProps> = ({ homeUser, startFunc }) => {
  const token = AuthService.getAuthToken();
  const progress = homeUser.home_progress + 1;

  if (token) {
    const mapURL = Constants.BACKEND_URL + '/progress-map?auth=' + encodeURIComponent(token);

    return (
      <Container>
        <Grid>
          <Map>
            <FrameWrapper>
              <Frame src={mapURL} title="Progress Map" scrolling="no" />
            </FrameWrapper>
          </Map>

          <LevelsWidget currentStep={progress}></LevelsWidget>

          <BadgesWidget currentStep={progress}></BadgesWidget>

          <AchievementsWidget />

          <StartButton onClick={startFunc}>
            <i className="fa fa-play progress_view_start_play_icon"></i>&nbsp;&nbsp;Start
          </StartButton>
        </Grid>
      </Container>
    );
  }

  return <></>;
};

export default ProgressMap;
